import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentRight12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextAlignmentRight12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 4a.5.5 0 0 0 0-1h-9a.5.5 0 0 0 0 1zm0 2a.5.5 0 0 0 0-1H3a.5.5 0 0 0 0 1zm.5 3.5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1 0-1h7.5a.5.5 0 0 1 .5.5M10.5 8a.5.5 0 0 0 0-1h-9a.5.5 0 0 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentRight12);
